import React from "react";
import { IoChevronForwardOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import MinimalPlans from "./MinimalPlans";

interface IProps {
  setShowSelectedPlans: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedPlans: React.Dispatch<React.SetStateAction<any[]>>;
  selectedPlans: any[];
};

const SelectedPlanSidebar = ({ setShowSelectedPlans, setSelectedPlans, selectedPlans }: IProps) => {
  const { t } = useTranslation();
  const tBase = "views.service-plan-dashboard.components.SelectedPlanSidebar";
  const tr = (key: string) => t(`${tBase}.${key}`);

  return (
    <div className="fixed top-[50px] right-0 w-[500px] h-[calc(100vh-50px)] bg-white shadow-lg z-10 transition-transform duration-300 ease-in-out">
      <button
        className="fixed p-0.5 z-10 top-[55px] right-[488px] text-primary border-2 border-primary bg-white rounded-full hover:bg-primary hover:text-white"
        onClick={() => setShowSelectedPlans(false)}
      >
        <IoChevronForwardOutline size={18} />
      </button>
      <div className={`
        fixed flex items-center justify-center w-[25.2px] h-[25.2px] z-10 top-[85px] right-[488px] text-white border-2 border-secondary bg-secondary rounded-full
        ${selectedPlans.length > 999 ? " text-[10px]" : " text-xs"}
      `}>
        {selectedPlans.length}
      </div>
      <div className="">
        <div className="flex items-center justify-between mb-2 border-b-2 border-primary pt-4 pb-[20px] pl-6 bg-slate-100">
          <h3 className="text-lg font-semibold ">
            {tr("Selected Service Plans")} {<span className="text-gray-500">({selectedPlans.length})</span>}
          </h3>
          <button
            onClick={() => {
              setSelectedPlans([]);
              setShowSelectedPlans(false);
            }}
            className="text-primary hover:text-primary-dark text-md mr-4"
          >
            {tr("Clear All")}
          </button>
        </div>
        {selectedPlans.length > 0 ? (
          <div className="max-h-[calc(100vh-130px)] overflow-y-auto pb-10 px-2">
            <div className=" list-decimal pl-2 ">
              <MinimalPlans
                plans={selectedPlans}
                setPlans={setSelectedPlans}
                setShow={setShowSelectedPlans}
              />

            </div>
          </div>
        ) : (
          <div className="text-gray-500 ml-4">
            {tr("No plans selected")}
          </div>
        )}
      </div>
    </div>
  )
}

export default SelectedPlanSidebar